var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientAbstract } from 'src/app/shared/service/http-client-abstract';
import { ToastrService } from 'ngx-toastr';
import { ModifyEmploymentStatusTextForWorkerPipe } from '../pipe/modify-employment-status-text-for-worker.pipe';
import { ModifyEmploymentStatusTextForProjectPipe } from '../pipe/modify-employment-status-text-for-project.pipe';
import { TranslateCountryOfCitizenshipTextPipe } from '../pipe/translate-country-of-citizenship-text.pipe';
import * as i0 from "@angular/core";
import * as i1 from "./http-header.service";
import * as i2 from "@angular/common/http";
import * as i3 from "ngx-toastr";
import * as i4 from "../pipe/modify-employment-status-text-for-worker.pipe";
import * as i5 from "../pipe/modify-employment-status-text-for-project.pipe";
import * as i6 from "../pipe/translate-country-of-citizenship-text.pipe";
var SearchConditionService = /** @class */ (function (_super) {
    __extends(SearchConditionService, _super);
    function SearchConditionService(header, http, toastrService, modifyEmploymentStatusTextForWorkerPipe, modifyEmploymentStatusTextForProjectPipe, translateCountryOfCitizenshipTextPipe) {
        var _this = _super.call(this, header, http) || this;
        _this.toastrService = toastrService;
        _this.modifyEmploymentStatusTextForWorkerPipe = modifyEmploymentStatusTextForWorkerPipe;
        _this.modifyEmploymentStatusTextForProjectPipe = modifyEmploymentStatusTextForProjectPipe;
        _this.translateCountryOfCitizenshipTextPipe = translateCountryOfCitizenshipTextPipe;
        return _this;
    }
    SearchConditionService.prototype.getRules = function () {
        return _super.prototype.requestGet.call(this, 'api/v1/default_search_rules');
    };
    SearchConditionService.prototype.updateRule = function (rule) {
        return _super.prototype.requestPost.call(this, 'api/v1/default_search_rules/update', rule);
    };
    SearchConditionService.prototype.getProjectRule = function () {
        return _super.prototype.requestGet.call(this, 'api/v1/default_search_rules/project');
    };
    SearchConditionService.prototype.getWorkerRule = function () {
        return _super.prototype.requestGet.call(this, 'api/v1/default_search_rules/worker');
    };
    // SearchConditionのバリデーション(検索欄のバリデーションを流用)
    SearchConditionService.prototype.areAttributesValidated = function (condition) {
        var isValidated = true;
        if (isValidated) {
            isValidated = this.isUnmatchNumber(condition.fee_from);
        }
        if (isValidated) {
            isValidated = this.isUnmatchNumber(condition.fee_to);
        }
        if (isValidated) {
            isValidated = this.isUnmatchNumber(condition.age_from);
        }
        if (isValidated) {
            isValidated = this.isUnmatchNumber(condition.age_to);
        }
        if (isValidated) {
            // tslint:disable-next-line:max-line-length
            if ((+condition.fee_to && +condition.fee_from > +condition.fee_to) ||
                (+condition.age_to && +condition.age_from > +condition.age_to)) {
                if (!!condition.fee_to && +condition.fee_from > +condition.fee_to) {
                    this.toastrService.info('金額の下限が上限値を上回っています。');
                    isValidated = false;
                }
                if (!!condition.age_to && +condition.age_from > +condition.age_to) {
                    this.toastrService.info('年齢の下限が上限値を上回っています。');
                }
                isValidated = false;
            }
        }
        return isValidated;
    };
    SearchConditionService.prototype.isUnmatchNumber = function (value) {
        if (!!value && isNaN(+value)) {
            this.toastrService.info('金額と年齢は半角数字を入力してください。');
            return false;
        }
        else {
            return true;
        }
    };
    SearchConditionService.prototype.resetSearchKeyword = function (condition) {
        condition.keyword = '';
    };
    SearchConditionService.prototype.resetSearchCondition = function (condition) {
        condition.keyword = '';
        condition.required_skills = '';
        condition.receipt_datetime = '0';
        condition.belongs = '0';
        condition.mail_from = '';
        condition.bp_rank = '0';
        condition.fee_from = '';
        condition.fee_to = '';
        condition.fee_null = true;
        condition.age_from = '';
        condition.age_to = '';
        condition.age_null = true;
        condition.employment_status = '0';
        condition.employment_status_null = true;
        condition.number_of_connect_company = '';
        condition.number_of_connect_company_null = true;
        condition.interview_times = '0';
        condition.interview_times_null = true;
        condition.work_immidiately = '0';
        condition.country_of_citizenship = '0';
        condition.country_of_citizenship_null = true;
        condition.work_location = '';
        condition.commute_location = '';
        condition.commute_time = '';
        condition.begin_from = null;
        condition.begin_to = null;
        condition.begin_null = true;
        condition.sender_hash_id = null;
    };
    // 詳細画面のデフォルト条件に軸メール条件を上書き
    SearchConditionService.prototype.overRideBaseMailCondition = function (condition, mailInfo) {
        // 人材詳細
        if (condition.mail_type === 'project') {
            // 金額
            if (mailInfo.fee) {
                condition.fee_from = mailInfo.fee.toString();
                condition.fee_to = this.maxProjectFee(mailInfo.fee).toString();
            }
            // 年齢
            if (mailInfo.age) {
                condition.age_from = mailInfo.age.toString();
            }
            // 時間(駅名)
            if (mailInfo.work_location) {
                condition.commute_location = mailInfo.work_location;
            }
            // 時間(分)
            if (mailInfo.commute_time) {
                condition.commute_time = mailInfo.commute_time;
            }
            // 雇用
            if (mailInfo.employment_status) {
                condition.employment_status = this.modifyEmploymentStatusTextForWorkerPipe.transformForCondition(mailInfo.employment_status);
            }
            // 案件詳細
        }
        else {
            // 金額
            if (mailInfo.fee) {
                condition.fee_from = this.minWorkerFee(mailInfo.fee).toString();
                condition.fee_to = mailInfo.fee.toString();
            }
            // 年齢
            if (mailInfo.age) {
                condition.age_to = mailInfo.age.toString();
            }
            // 時間(駅名)
            if (mailInfo.work_location) {
                condition.commute_location = mailInfo.work_location;
            }
            // 時間(分)
            if (mailInfo.commute_time) {
                condition.commute_time = mailInfo.commute_time;
            }
            // 雇用
            if (mailInfo.employment_status) {
                condition.employment_status = this.modifyEmploymentStatusTextForProjectPipe.transformForCondition(mailInfo.employment_status);
            }
        }
        // 商深
        if (mailInfo.number_of_connect_company != null) {
            condition.number_of_connect_company = mailInfo.number_of_connect_company.toString();
        }
        // 国籍
        if (mailInfo.country_of_citizenship) {
            condition.country_of_citizenship = this.translateCountryOfCitizenshipTextPipe.transformForCondition(mailInfo.country_of_citizenship, condition.mail_type);
        }
        // 面談
        if (mailInfo.interview_times != null) {
            condition.interview_times = mailInfo.interview_times.toString();
        }
        // 自社メールの場合
        if (mailInfo.belong_to_own_company) {
            condition.gross_margin_setting = 0;
        }
        return condition;
    };
    SearchConditionService.prototype.minWorkerFee = function (feeTo) {
        return Math.floor(Math.min(feeTo - 20, feeTo * 0.7));
    };
    SearchConditionService.prototype.maxProjectFee = function (feeFrom) {
        return Math.floor(Math.max(feeFrom + 20, feeFrom * (10 / 7)));
    };
    // searchTag（青タグ）の条件を検索条件に上書き
    SearchConditionService.prototype.overRideSearchTagCondition = function (searchParams, searchTag) {
        var tagParams = {};
        searchTag.search_tag_items.forEach(function (searchTagItem) {
            tagParams["" + searchTagItem.column_name] = searchTagItem.search_value;
        });
        // tslint:disable-next-line:forin
        for (var key in tagParams) {
            switch (key) {
                // キーワード検索は後置連結
                case 'keyword':
                    searchParams[key] += ' ' + tagParams[key];
                    break;
                // Null検索はBool値に変換して入力
                case key.endsWith('null') && key:
                    searchParams[key] = 'true' === tagParams[key];
                    break;
                default:
                    searchParams[key] = tagParams[key];
            }
        }
    };
    // タグ作成に不必要な属性をsearchParamsから削除
    // 不必要な属性・・・タグの絞り込みで使用しない属性とデフォルトの値と変わらないもの
    SearchConditionService.prototype.tagParams = function (searchParams) {
        var copySearchParams = Object.assign({}, searchParams);
        this.unnecessaryProps().forEach(function (unnecessaryProp) {
            delete copySearchParams[unnecessaryProp];
        });
        var defaultParams = new SearchCondition({});
        var diffProps = Object.keys(copySearchParams).filter(function (k) { return copySearchParams[k] !== defaultParams[k]; });
        var tagParams = {};
        diffProps.forEach(function (prop) {
            tagParams[prop] = copySearchParams[prop];
        });
        return tagParams;
    };
    // searchConditionで、タグ作成に不必要な属性
    SearchConditionService.prototype.unnecessaryProps = function () {
        return [
            'id',
            'user_id',
            'active_tab_id',
            'created_at',
            'updated_at',
            'gross_margin_setting',
            'belongs'
        ];
    };
    SearchConditionService.ngInjectableDef = i0.defineInjectable({ factory: function SearchConditionService_Factory() { return new SearchConditionService(i0.inject(i1.HttpHeaderService), i0.inject(i2.HttpClient), i0.inject(i3.ToastrService), i0.inject(i4.ModifyEmploymentStatusTextForWorkerPipe), i0.inject(i5.ModifyEmploymentStatusTextForProjectPipe), i0.inject(i6.TranslateCountryOfCitizenshipTextPipe)); }, token: SearchConditionService, providedIn: "root" });
    return SearchConditionService;
}(HttpClientAbstract));
export { SearchConditionService };
